module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookrack"
  }, [_c('div', {
    staticClass: "bookrack-topBar"
  }, [_c('div', {
    staticClass: "bookrack-topNav"
  }, [_c('div', {
    staticClass: "bookrack-topNav-left"
  }, [_c('div', {
    staticClass: "bookrack-backBox",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-arrow-back",
      "color": "#fff",
      "size": "32"
    }
  })], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "bookrack-topNav-right"
  }, [_c('div', {
    staticClass: "bookrack-homeBox"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/home"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "home",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "bookrack-personalBox"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/login"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "android-person",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "bookrack-container"
  }, [(_vm.bookDetailList.length > 0) ? _c('ul', _vm._l((_vm.bookDetailList), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "exact": "",
        "to": '/bookdetails/' + item.title + '&' + item.catalogId
      }
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.bookDetailList.length == 0) ? _c('div', [_vm._v("\n      书架还没有东西\n      "), _c('router-link', {
    attrs: {
      "to": "/home"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("去书城逛逛")])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearBookrack"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.clearBookrack();
        _vm.$router.go(0)
      }
    }
  }, [_vm._v("一键清空书架")])]), _vm._v(" "), _c('recommend'), _vm._v(" "), _c('bookrack-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookrack-titleBox"
  }, [_c('span', {
    staticClass: "bookrack-title"
  }, [_vm._v("我的书架")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-7f9e5568","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/bookrack/index.vue
// module id = 191
// module chunks = 1